import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import "./index.css";

import { MultiStepForm } from "./pages/MultiStepForm";
import { Toaster } from '@/components/ui/sonner';

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MultiStepForm />}></Route>
        <Route path="/sarlaft" element={<MultiStepForm />} />
      </Routes>
      <Toaster richColors />
    </BrowserRouter>
  </StrictMode>
);
